export enum DrawerErrorSource {
  BACKEND = "backend",
  FRONTEND = "frontend",
}

export interface DrawerErrorResponseData {
  data?: {
    errors?: Record<string, string[]>;
    status?: number;
  };
}

export class DrawerError extends Error {
  source: DrawerErrorSource;
  status?: number;
  responseData?: DrawerErrorResponseData;

  constructor(source: DrawerErrorSource, status?: number, responseData?: DrawerErrorResponseData) {
    super("Error loading drawer");

    this.source = source;
    this.status = status;
    this.responseData = responseData;
  }
}
